import { AllReviewersByEmployeeIdQuery, AllReviewersByEmployeeIdQueryVariables } from './../../../../../integration-tests/common/types'
import { ApolloError, useQuery } from '@apollo/client'
import { REVIEWERS_OF_EMPLOYEEE } from '../Queries'

export default (
  employeeId: number,
): {
  data: AllReviewersByEmployeeIdQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const variables = {
    employeeId: employeeId,
  }

  const { data, error, loading } = useQuery<AllReviewersByEmployeeIdQuery, AllReviewersByEmployeeIdQueryVariables>(REVIEWERS_OF_EMPLOYEEE, {
    variables: variables,
  })

  return { data, error, loading }
}
